module.exports = __webpack_public_path__ + "img/big-money.41a7dce8.png";